import { DatePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IonDatetime, PopoverController } from '@ionic/angular';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { SelectorFechaComponent } from '../selector-fecha/selector-fecha.component';

@Component({
  selector: 'app-filtros-consultas',
  templateUrl: './filtros-consultas.component.html',
  styleUrls: ['./filtros-consultas.component.scss'],
})
export class FiltrosConsultasComponent implements OnInit {
  @Input() search: boolean = true;
  @Input() Tipo: boolean = false;
  @Input() Tipo2: boolean = false;
  @Input() Estudiante: boolean = false;
  @Input() Fecha: boolean = false;
  @Input() Resumen: boolean = false;
  @Input() Aplicaciones: boolean = false;

  @Input() Desabilitar:boolean=false;

  @Output() evFiltro = new EventEmitter();
  @Output() evFiltroTipo = new EventEmitter();
  @Output() evFiltroTipo2 = new EventEmitter();
  @Output() evFecha = new EventEmitter();
  @Output() evAplicaciones = new EventEmitter();
  @Output() evResumido = new EventEmitter();
  @Output() evRPorEstudiante = new EventEmitter();

  d: boolean = false;
  r: boolean = false;
  e: boolean = false;

  @ViewChild(IonDatetime, { static: true }) datetime: IonDatetime;
  dateValue1 = '';
  dateValue2 = '';
  openPopover: boolean = false;

  @Input() Documentos = [];
  @Output() recargar = new EventEmitter();

  Consulta = '';
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  filtro = '';
  filtrado = false;

  datePipe = new DatePipe('en-US');
  constructor(
    private conexion: ConexionService,
    private utilidades: UtilidadesService,
    private popoverController: PopoverController
  ) {
    if (localStorage.getItem('FechasConsultas')) {
      let f = JSON.parse(localStorage.getItem('FechasConsultas'));
      this.range.patchValue({
        start: f.Fecha1,
        end: f.Fecha2,
      });
    } else {
      let f2 = this.fDate(new Date());
      let f1 = localStorage.getItem("FechaInicioAnio");
      this.range.patchValue({
        start: f1,
        end: f2,
      });
    }
  }

  fDate(date) {
    return this.datePipe.transform(date, 'yyyy-MM-dd', 'GMT');
  }

  @Input() HijosSeleccionados = [];
  @Input() HijosSelect = [];
  @Output() newHijosSeleccionados = new EventEmitter();
  @Input() TodosSeleccionadosAlIniciar = true;

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // if (this.HijosSeleccionados.length == 0) {
    //   for (let i of this.Hijos) {
    //     this.HijosSeleccionados.push(i.Id);
    //   }
    // }

    if(this.TodosSeleccionadosAlIniciar ){
      this.HijosSeleccionados = []
      for(let i of this.HijosSelect){
        if(!this.HijosSeleccionados.includes(i.Value)){
          this.HijosSeleccionados.push(i.Value);
        }
      }
      this.newHijosSeleccionados.emit(this.HijosSeleccionados);
    }

    // setTimeout(() => {
    //   if (this.HijosSelect.length == 0) {
    //     this.HijosSeleccionados = [];
    //     for (let i of this.Hijos) {
    //       this.HijosSelect.push({
    //         Nombre: i.Nombre1 + ' ' + i.Apellido1,
    //         Foto: i.Url,
    //         Value: i.IdCurso,
    //       });
    //       this.HijosSeleccionados.push(i.IdCurso);
    //     }
    //   }

    //   this.newHijosSeleccionados.emit(this.HijosSeleccionados);
    // }, 50);
  }

  ngOnInit() {
    this.CambioFecha();
    
  }

  CambioFecha() {
    let evF = {
      Fecha1: this.fDate(this.range.value.start),
      Fecha2: this.fDate(this.range.value.end),
    };
    if (!evF.Fecha1) {
      this.range.patchValue({ start: '1999-01-01' });
    }

    if (!evF.Fecha2) {
      this.range.patchValue({ end: this.fDate(new Date()) });
    }

    evF = {
      Fecha1: this.fDate(this.range.value.start),
      Fecha2: this.fDate(this.range.value.end),
    };
    localStorage.setItem('FechasConsultas', JSON.stringify(evF));
    this.evFecha.emit(evF);
  }

  yaPopover: boolean = false;
  async FechaPopover(e: Event, variable: number) {
    if (this.yaPopover) return 0;
    this.yaPopover = true;
    setTimeout(() => {
      this.yaPopover = false;
    }, 1000);
    let fecha = '';
    if (variable == 1) {
      fecha = this.dateValue1;
    } else {
      fecha = this.dateValue2;
    }

    const popover = await this.popoverController.create({
      component: SelectorFechaComponent,
      event: e,
      componentProps: {
        setFecha: fecha,
      },
      mode: 'md',
    });

    await popover.present();

    popover.onDidDismiss().then((date) => {
      if (variable == 1) {
        this.range.patchValue({
          start: this.datePipe.transform(date.data, 'yyyy-MM-dd'),
        });
      } else {
        this.range.patchValue({
          end: this.datePipe.transform(date.data, 'yyyy-MM-dd'),
        });
      }
      if (this.openPopover) {
        this.openPopover = false;
        setTimeout(() => {
          this.openPopover = true;
        }, 10);
      }

      this.CambioFecha();
    });
  }
}
